import { useState, useEffect } from "react";
import LayoutWeb from "../LayoutWeb/layoutWeb";
import BlogForm from "./BlogForm";
import "./Blog.scss";
import { deleteBlog, getAllBlogs } from "../../api/blogs.api";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [currentBlog, setCurrentBlog] = useState(null);

  // Función para obtener los datos de la API
  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const data = await getAllBlogs();
      setBlogs(data);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  // Cargar blogs al montar el componente
  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleEdit = (blog) => {
    setCurrentBlog(blog);
    setShowForm(true);
  };

  const handleCreate = () => {
    setCurrentBlog(null);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de que deseas eliminar este post?")) {
      try {
        await deleteBlog(id);
        fetchBlogs(); // Refrescar lista tras eliminar
      } catch (error) {
        console.error("Error al eliminar:", error);
      }
    }
  };

  const closeBlockForm = () => {
    setShowForm(false);
    setCurrentBlog(null);
  };

  return (
    <LayoutWeb subTitle="Gestión de Blog">
      <div className="BlogHeader">
        <h1>
          {showForm
            ? currentBlog
              ? "Editando Post"
              : "Nuevo Post"
            : "Blog CMS"}
        </h1>
        {!showForm ? (
          <button className="btn-primary" onClick={handleCreate}>
            + Nuevo Post
          </button>
        ) : (
          <button className="btn-close" onClick={closeBlockForm}>
            &times;
          </button>
        )}
      </div>

      {showForm ? (
        <BlogForm
          blogData={currentBlog}
          closeForm={closeBlockForm}
          refreshData={fetchBlogs}
        />
      ) : loading ? (
        <div className="loading-state">Cargando posts...</div>
      ) : blogs.length === 0 ? (
        <p>No hay publicaciones disponibles.</p>
      ) : (
        <div className="BlogGrid">
          {blogs.map((post) => (
            <div key={post._id} className="BlogCard">
              <div className="BlogCard__image-container">
                <img
                  src={post.image}
                  alt={post.title}
                  className="BlogCard__img"
                />
                {post.active === false && (
                  <span className="badge-draft">Borrador</span>
                )}
              </div>
              <div className="BlogCard__content">
                <h3>{post.title}</h3>
                <p>
                  {post.description?.substring(0, 100) || "Sin descripción"}
                  ...
                </p>
                <div className="BlogCard__actions">
                  <button onClick={() => handleEdit(post)} className="btn-edit">
                    Editar
                  </button>
                  <button
                    onClick={() => handleDelete(post._id)}
                    className="btn-delete"
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </LayoutWeb>
  );
};

export default Blog;
